// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import userService from "../services/userService";
// import logo from "../images/logo.png";

// export default function InviteLanding() {
//   const { token } = useParams();

//   const [loading, setLoading] = useState(true);
//   const [invite, setInvite] = useState(null);
//   const [cleanerExists, setCleanerExists] = useState(false);
//   const [error, setError] = useState(null);

//   // Deep link & store URLs
//   const DEEP_LINK = `com.flavoursoft.freshsweeperv5://invite/${token}`;
//   const APPLE_STORE = "https://apps.apple.com/app/idXXXXXXXX"; // Replace with your App Store ID
//   const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.flavoursoft.freshsweeperv5";

//   useEffect(() => {
//     if (token) fetchInvite();
//   }, [token]);

//   const fetchInvite = async () => {
//     try {
//       const res = await userService.getInviteToken(token);
//       setInvite(res.data.invite);
//       setCleanerExists(res.data.cleanerExists); // true if cleaner already registered
//     } catch (err) {
//       setError("Invalid or expired invite");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handles deep link with store fallback
//   const openAppOrStore = () => {
//     const start = Date.now();

//     // Attempt to open the app
//     window.location.href = DEEP_LINK;

//     setTimeout(() => {
//       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//       const isAndroid = /Android/.test(navigator.userAgent);

//       // If app did not open
//       if (Date.now() - start < 2000) {
//         if (isIOS) {
//           window.location.href = APPLE_STORE;
//         } else if (isAndroid) {
//           window.location.href = PLAY_STORE;
//         }
//       }
//     }, 1500);
//   };

//   const handleRedirectToApp = () => {
//     // If the cleaner is already registered and logged in
//     if (canAutoAccept) {
//       // Directly open property in the app
//       window.location.href = `${deepLink}property/${invite.propertyId}?inviteToken=${token}`;
//     }
//     // If the cleaner exists but NOT logged in
//     else if (cleanerExists) {
//       // Redirect to login in the app, pass invite token
//       window.location.href = `${deepLink}login?inviteToken=${token}`;
//     }
//     // If the cleaner doesn't exist
//     else {
//       // Redirect to registration in the app, pass invite token
//       window.location.href = `${deepLink}register-cleaner?inviteToken=${token}`;
//     }
//   };


//   if (loading) return <div style={{ padding: 40 }}>Loading invite...</div>;

//   if (error)
//     return (
//       <div style={{ padding: 40 }}>
//         <h2>{error}</h2>
//       </div>
//     );

//   return (
//     <div style={styles.page}>
//       {/* LOGO */}
//       <img src={logo} alt="Freshsweeper" style={styles.logo} />

//       <div style={styles.card}>
//         {/* PROPERTY IMAGE */}
//         {invite.propertyPhoto ? (
//           <img src={invite.propertyPhoto} style={styles.propertyImage} />
//         ) : (
//           <div style={styles.placeholder}></div>
//         )}

//         <h1>You’ve been invited to clean this property</h1>
//         <h2>{invite.propertyName}</h2>
//         <p style={styles.address}>{invite.address}</p>

//         {/* HOST INFO */}
//         <div style={styles.hostSection}>
//           <img src={invite.host_avatar} alt="Host" style={styles.hostPhoto} />
//           <div>
//             <strong>{invite.hostName}</strong>
//             <div style={{ fontSize: 13, color: "#666" }}>Property Owner</div>
//           </div>
//         </div>

//         {/* EARNINGS */}
//         <div style={styles.earningsBox}>
//           Earn approximately <strong>${invite.estimatedEarnings}</strong> per cleaning
//         </div>

//         {/* TRUST MESSAGE */}
//         <div style={styles.trust}>
//           Secure payments • Flexible schedule • No subscription required
//         </div>

//         {/* ACTION BUTTON */}
//         <button style={styles.button} onClick={openAppOrStore}>
//           {cleanerExists ? "Accept Invite" : "Create Account & Accept Invite"}
//         </button>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   page: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: 20,
//     backgroundColor: "#f5f7fb",
//     minHeight: "100vh",
//   },

//   logo: {
//     width: 120,
//     marginBottom: 25,
//   },

//   card: {
//     width: "100%",
//     maxWidth: 500,
//     backgroundColor: "white",
//     borderRadius: 12,
//     padding: 25,
//     boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
//     textAlign: "center",
//   },

//   propertyImage: {
//     width: "100%",
//     height: 200,
//     objectFit: "cover",
//     borderRadius: 8,
//     marginBottom: 15,
//   },

//   placeholder: {
//     height: 200,
//     borderRadius: 8,
//     marginBottom: 15,
//     backgroundImage:
//       "url('https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=800&q=80')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   },

//   address: {
//     color: "#666",
//     marginBottom: 20,
//   },

//   hostSection: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 12,
//     marginBottom: 20,
//   },

//   hostPhoto: {
//     width: 50,
//     height: 50,
//     borderRadius: "50%",
//     objectFit: "cover",
//   },

//   earningsBox: {
//     backgroundColor: "#eef4ff",
//     padding: 15,
//     borderRadius: 8,
//     marginBottom: 15,
//     fontSize: 16,
//   },

//   trust: {
//     fontSize: 13,
//     color: "#777",
//     marginBottom: 20,
//   },

//   button: {
//     width: "100%",
//     padding: 14,
//     backgroundColor: "#2b71f0",
//     color: "white",
//     border: "none",
//     borderRadius: 8,
//     fontSize: 16,
//     cursor: "pointer",
//   },
// };



// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import userService from "../services/userService";
// import logo from "../images/logo.png";

// export default function InviteLanding() {
//   const { token } = useParams();

//   const [loading, setLoading] = useState(true);
//   const [invite, setInvite] = useState(null);
//   const [cleanerExists, setCleanerExists] = useState(false);
//   const [error, setError] = useState(null);

//   // Deep link & store URLs
//   const DEEP_LINK_BASE = "com.flavoursoft.freshsweeperv5://";
//   const APPLE_STORE = "https://apps.apple.com/app/idXXXXXXXX"; // Replace with your App Store ID
//   const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.flavoursoft.freshsweeperv5";

//   // Get current logged-in cleaner (if any)
//   const currentUser = JSON.parse(localStorage.getItem("currentCleaner"));
 
//   useEffect(() => {
//     if (token) fetchInvite();
//   }, [token]);

//   const fetchInvite = async () => {
//     try {
//       const res = await userService.getInviteToken(token);

//       setCleanerExists(res.data.cleanerExists);
//     } catch (err) {
//       setError("Invalid or expired invite");
//     } finally {
//       setLoading(false);
//     }
//   };

  

//   const openAppOrStore = (path) => {
//     const url = `${DEEP_LINK_BASE}${path}`;
//     console.log("Attempting deep link:", url);
  
//     const start = Date.now();
  
//     window.location.href = url;
  
//     setTimeout(() => {
//       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//       const isAndroid = /Android/.test(navigator.userAgent);
  
//       console.log("Fallback check triggered");
  
//       if (Date.now() - start < 2000) {
//         if (isIOS) {
//           console.log("Redirecting to Apple Store");
//           window.location.href = APPLE_STORE;
//         } else if (isAndroid) {
//           console.log("Redirecting to Play Store");
//           window.location.href = PLAY_STORE;
//         } else {
//           console.log("Desktop detected - no store redirect");
//         }
//       }
//     }, 1500);
//   };


//   const handleRedirectToApp = () => {
//     if (!invite) return;

//    if (cleanerExists) {
//       // Registered but not logged in → login
//       openAppOrStore(`login?inviteToken=${token}`);
//     } else {
//       // New cleaner → registration
//       // openAppOrStore(`login`);
//       // openAppOrStore(`PropertyDetails/${invite.propertyId}?inviteToken=${token}`);
//       // openAppOrStore('PropertyDetails')
//       openAppOrStore(`register-cleaner?inviteToken=${token}&userType=cleaner`);
//     }
//   };

//   if (loading) return <div style={{ padding: 40 }}>Loading invite...</div>;
//   if (error)
//     return (
//       <div style={{ padding: 40 }}>
//         <h2>{error}</h2>
//       </div>
//     );

//   return (
//     <div style={styles.page}>
//       {/* LOGO */}
//       <img src={logo} alt="Freshsweeper" style={styles.logo} />

//       <div style={styles.card}>
//         {/* PROPERTY IMAGE */}
//         {invite.propertyPhoto ? (
//           <img src={invite.propertyPhoto} style={styles.propertyImage} />
//         ) : (
//           <div style={styles.placeholder}></div>
//         )}

//         <h1>You've been invited to clean this property</h1>
//         <h2>{invite.propertyName}</h2>
//         <p style={styles.address}>{invite.address}</p>

//         {/* HOST INFO */}
//         <div style={styles.hostSection}>
//           <img src={invite.host_avatar} alt="Host" style={styles.hostPhoto} />
//           <div>
//             <strong>{invite.hostName}</strong>
//             <div style={{ fontSize: 13, color: "#666" }}>Property Owner</div>
//           </div>
//         </div>

//         {/* EARNINGS */}
//         <div style={styles.earningsBox}>
//           Earn approximately <strong>${invite.estimatedEarnings}</strong> per cleaning
//         </div>

//         {/* TRUST MESSAGE */}
//         <div style={styles.trust}>
//           Secure payments • Flexible schedule • No subscription required
//         </div>

//         {/* ACTION BUTTON */}
//         <button style={styles.button} onClick={handleRedirectToApp}>
//           {cleanerExists
//             ? "Accept Invite"
//             : "Create Account & Accept Invite"}
//         </button>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   page: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: 20,
//     backgroundColor: "#f5f7fb",
//     minHeight: "100vh",
//   },

//   logo: {
//     width: 30,
//     marginBottom: 25,
//   },

//   card: {
//     width: "100%",
//     maxWidth: 500,
//     backgroundColor: "white",
//     borderRadius: 12,
//     padding: 25,
//     boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
//     textAlign: "center",
//   },

//   propertyImage: {
//     width: "100%",
//     height: 200,
//     objectFit: "cover",
//     borderRadius: 8,
//     marginBottom: 15,
//   },

//   placeholder: {
//     height: 200,
//     borderRadius: 8,
//     marginBottom: 15,
//     backgroundImage:
//       "url('https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=800&q=80')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   },

//   address: {
//     color: "#666",
//     marginBottom: 20,
//   },

//   hostSection: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 12,
//     marginBottom: 20,
//   },

//   hostPhoto: {
//     width: 50,
//     height: 50,
//     borderRadius: "50%",
//     objectFit: "cover",
//   },

//   earningsBox: {
//     backgroundColor: "#eef4ff",
//     padding: 15,
//     borderRadius: 8,
//     marginBottom: 15,
//     fontSize: 16,
//   },

//   trust: {
//     fontSize: 13,
//     color: "#777",
//     marginBottom: 20,
//   },

//   button: {
//     width: "100%",
//     padding: 14,
//     backgroundColor: "#2b71f0",
//     color: "white",
//     border: "none",
//     borderRadius: 8,
//     fontSize: 16,
//     cursor: "pointer",
//   },
// };





import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import userService from "../services/userService";
import logo from "../images/logo.png";

export default function InviteLanding() {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const [cleanerExists, setCleanerExists] = useState(false);
  const [error, setError] = useState(null);

  // Deep link & store URLs
  const DEEP_LINK_BASE = "com.flavoursoft.freshsweeperv5://";
  const APPLE_STORE = "https://apps.apple.com/app/idXXXXXXXX"; // Replace with your App Store ID
  const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.flavoursoft.freshsweeperv5";

 
  useEffect(() => {
    if (token) fetchInvite();
  }, [token]);

  const fetchInvite = async () => {
    try {
      const res = await userService.getInviteToken(token);
      console.log(res.data)
      setInvite(res.data.invite);
      setCleanerExists(res.data.cleanerExists);
    } catch (err) {
      setError("Invalid or expired invite");
    } finally {
      setLoading(false);
    }
  };

  

  const openAppOrStore = (path) => {
    const url = `${DEEP_LINK_BASE}${path}`;
    console.log("Attempting deep link:", url);
  
    const start = Date.now();
  
    window.location.href = url;
  
    setTimeout(() => {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);
  
      console.log("Fallback check triggered");
  
      if (Date.now() - start < 2000) {
        if (isIOS) {
          console.log("Redirecting to Apple Store");
          window.location.href = APPLE_STORE;
        } else if (isAndroid) {
          console.log("Redirecting to Play Store");
          window.location.href = PLAY_STORE;
        } else {
          console.log("Desktop detected - no store redirect");
        }
      }
    }, 1500);
  };


  const handleRedirectToApp = () => {
    if (!invite) return;

   if (cleanerExists) {
      // Registered but not logged in → login
      openAppOrStore(`invite?inviteToken=${token}`);
      // openAppOrStore(`property-details?inviteToken=${token}`);
    } else {
      openAppOrStore(`register-cleaner?inviteToken=${token}&userType=cleaner`);
    }
  };

  if (loading) return <div style={{ padding: 40 }}>Loading invite...</div>;
  if (error)
    return (
      <div style={{ padding: 40 }}>
        <h2>{error}</h2>
      </div>
    );

  return (
    <div style={styles.page}>
      {/* LOGO */}
      <img src={logo} alt="Freshsweeper" style={styles.logo} />

      <div style={styles.card}>
        {/* PROPERTY IMAGE */}
        {invite.propertyPhoto ? (
          <img src={invite.propertyPhoto} style={styles.propertyImage} />
        ) : (
          <div style={styles.placeholder}></div>
        )}

        <h1>You've been invited to clean this property</h1>
        <h2>{invite.propertyName}</h2>
        <p style={styles.address}>{invite.address}</p>

        {/* HOST INFO */}
        <div style={styles.hostSection}>
          <img src={invite.host_avatar} alt="Host" style={styles.hostPhoto} />
          <div>
            <strong>{invite.hostName}</strong>
            <div style={{ fontSize: 13, color: "#666" }}>Property Owner</div>
          </div>
        </div>

        {/* EARNINGS */}
        <div style={styles.earningsBox}>
          Earn approximately <strong>${invite.estimatedEarnings}</strong> per cleaning
        </div>

        {/* TRUST MESSAGE */}
        <div style={styles.trust}>
          Secure payments • Flexible schedule • No subscription required
        </div>

        {/* ACTION BUTTON */}
        <button style={styles.button} onClick={handleRedirectToApp}>
          {cleanerExists
            ? "Accept Invite"
            : "Create Account & Accept Invite"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#f5f7fb",
    minHeight: "100vh",
  },

  logo: {
    width: 30,
    marginBottom: 25,
  },

  card: {
    width: "100%",
    maxWidth: 500,
    backgroundColor: "white",
    borderRadius: 12,
    padding: 25,
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    textAlign: "center",
  },

  propertyImage: {
    width: "100%",
    height: 200,
    objectFit: "cover",
    borderRadius: 8,
    marginBottom: 15,
  },

  placeholder: {
    height: 200,
    borderRadius: 8,
    marginBottom: 15,
    backgroundImage:
      "url('https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=800&q=80')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  address: {
    color: "#666",
    marginBottom: 20,
  },

  hostSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    marginBottom: 20,
  },

  hostPhoto: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    objectFit: "cover",
  },

  earningsBox: {
    backgroundColor: "#eef4ff",
    padding: 15,
    borderRadius: 8,
    marginBottom: 15,
    fontSize: 16,
  },

  trust: {
    fontSize: 13,
    color: "#777",
    marginBottom: 20,
  },

  button: {
    width: "100%",
    padding: 14,
    backgroundColor: "#2b71f0",
    color: "white",
    border: "none",
    borderRadius: 8,
    fontSize: 16,
    cursor: "pointer",
  },
};